<script lang="ts" setup>
import type { NuxtError } from '#app'
// TODO: not every error is 404, do we want to always show 404 page on error.vue, or handle different codes?
// it would useful to still somehow show default nuxt error page in development

const props = defineProps<{
  error: NuxtError
}>()

onShowLogs(() => console.log('[error.vue]', props.error))
</script>

<template>
  <NuxtLayout name="default">
    <Page404 />
  </NuxtLayout>
</template>
